import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { Button, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useRecordContext } from 'react-admin';
import { adjustableModels } from '../lib/artboards';
import { AppArt } from '../types';
import AdjustDialog from './AdjustDialog';

/**
 * O ajuste no cabeçalho, ao lado de "Gerar modelos": é o caminho de quem chega
 * pela tela e ainda vai escolher de qual modelo está falando. O mesmo diálogo
 * abre do card do modelo, já apontado para ele.
 */
const AdjustCommandButton = () => {
  const record = useRecordContext<AppArt>();
  const [open, setOpen] = useState(false);

  if (!record) { return null; }

  const folhas = adjustableModels(record.files || []);

  // Sem modelo gerado não há o que ajustar: o botão nem aparece.
  if (!folhas.length) { return null; }

  return (
    <>
      <Tooltip title="O cliente quer aquela arte com um detalhe diferente">
        <span>
          <Button
            size="small"
            variant="outlined"
            startIcon={<AutoFixHighIcon />}
            onClick={() => setOpen(true)}
          >
            Pedir ajuste
          </Button>
        </span>
      </Tooltip>

      <AdjustDialog
        open={open}
        onClose={() => setOpen(false)}
        chainId={record.chainId}
        chainName={record.chainName}
        models={folhas}
      />
    </>
  );
};

export default AdjustCommandButton;
